import React, {useEffect, useState} from 'react';
import TextField from "@material-ui/core/TextField";
import {Button, CountrySelect, Typography} from "@nzpost/react-components";
import get from 'lodash/get';
import {FormHelperText, withStyles} from "@material-ui/core";
import CloseIcon from "./CloseIcon";
import {Controller, useFormContext} from "react-hook-form";
import {specialCharErrorMsg, specialCharRegex, isValidHSTariff} from "./utils";
import SearchIcon from "./SearchIcon";
import GreenTick from "./GreenTick";
import isEmpty from "lodash/isEmpty";
import ReactGA from "react-ga4";

//numeric validation
const numericKeyPressOnly = (maxWholePart, maxDecimals) => (e) => {
  const inputValue = e.target.value;

  // Block paste operations completely
  if ((e.metaKey || e.ctrlKey) && e.keyCode === 86) {
    e.preventDefault();
    return;
  }


  // Allow digits from top row and numpad
  const isDigit = (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105);
  const isDot = (maxDecimals > 0 && e.key === '.' && !inputValue.includes('.'));

  // Allow backspace, tab, arrow keys, and decimal point (.)
  const isControlKey = e.keyCode === 8 || e.keyCode === 9 || (e.keyCode >= 37 && e.keyCode <= 40) || isDot;

  // Allow Ctrl+A, Ctrl+C, Ctrl+V
  const isCtrlCombination = ((e.metaKey || e.ctrlKey) && (e.keyCode === 65 || e.keyCode === 67 || e.keyCode === 86));

  // Check if there is a decimal point in the value
  const decimalIndex = inputValue.indexOf('.');

  // If the cursor is before the decimal or no decimal yet, we're typing in the whole number part
  const isBeforeDecimal = decimalIndex === -1 || e.target.selectionStart <= decimalIndex;
  // If there is a decimal point, check how many digits are after it
  const isAfterDecimal = decimalIndex !== -1 && e.target.selectionStart > decimalIndex;
  const hasTooManyDecimals = decimalIndex !== -1 && inputValue.slice(decimalIndex + 1).length >= maxDecimals;
  // Restrict the whole number part to maxWholePart digits
  const wholeNumberPart = decimalIndex !== -1 ? inputValue.slice(0, decimalIndex) : inputValue;
  const hasTooManyWholeDigits = wholeNumberPart.length >= maxWholePart && !isAfterDecimal;

  // Block other non-numeric keys
  if (
    //block non digits, but still allow for backspace, tab, arrow keys, and decimal point
    !isDigit && !isControlKey && !isCtrlCombination
    // else block overflowing decimals or whole integer part
    || (isDigit && isAfterDecimal && hasTooManyDecimals)
    || (isDigit && isBeforeDecimal && hasTooManyWholeDigits)
  ) {
    e.preventDefault();
  }
};

const NewItemForm = ({
                       index,
                       setValue,
                       setError,
                       clearErrors,
                       isSubmitted,
                       errors,
                       control,
                       trigger,
                       remove,
                       multiple,
                       itemRef,
                       countryOriginRequired = false,
                       countryHasValidation,
                       currentCountry
                     }) => {
// Inside your component

  const [manualEntryMode, setManualEntryMode] = useState(false);
  const [manualEntryError, setManualEntryModeError] = useState(false);
  const [hsTariff, setHsTariff] = useState(null);
  const [stopWordErrors, setStopWordErrors] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  const selectedTarifCode = get(control._formValues, `items.${index}.tarifCode`, '');

  console.log({
    selectedTarifCode,
    manualEntryError,
    hsTariff,
    "get(hsTariff, 'hsCode.code', '')": get(hsTariff, 'hsCode.code', ''),
    "selectedTarifCode === get(hsTariff, 'hsCode.code', '')": selectedTarifCode === get(hsTariff, 'hsCode.code', '')
  });

  const DeleteButton = withStyles({
    root: {
      margin: '0',
      // paddingTop: '0',
      // paddingBottom: '0',
    },
    label: {
      color: `var(--NZPOST-Key-colours-Secondary, #0033A0)`,
      fontFeatureSettings: "'liga' off, 'clig' off",
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '22px',
      letterSpacing: '0.1px'
    }
  })(Button);

  useEffect(() => {
    setValue(`items.${index}.tarifCode`, '', {shouldValidate: true});
    setValue(`items.${index}.manualTarifCode`, '', {houldValidate: true});
    setHsTariff(null);
    setStopWordErrors(false);
    setManualEntryMode(false);
    setIsDirty(false);
    clearErrors(`items.${index}.description`);
    clearErrors(`items.${index}.tarifCode`);
    clearErrors(`items.${index}.manualTarifCode`);
  }, [currentCountry]);

  useEffect(() => {
    if (isSubmitted) {
      setIsDirty(true);

      console.log('triggering manualTarifCode validation after setting isDirty true');

      setTimeout(() => {
        trigger(`items.${index}.description`);
        trigger(`items.${index}.tarifCode`);
        trigger(`items.${index}.manualTarifCode`);
      }, 0)

    }
  }, [isSubmitted]);

  const validateAndSearchTariff = () => {
    const description = get(control._formValues, `items.${index}.description`, '');
    if (isEmpty(description)) {
      setValue(`items.${index}.description`, '', {shouldTouch: true, shouldValidate: true})
      return;
    }
    if (!currentCountry || isEmpty(currentCountry)) {
      trigger(`toCountry`);
      setError(`items.${index}.description`, {
        type: "manual",
        message: "Parcel destination country must be selected before tariff code search."
      });
      setValue(`items.${index}.description`, description, {shouldTouch: true})
      return;
    }
    //reset current selected tariff code
    setValue(`items.${index}.tarifCode`, '', {shouldValidate: true});
    setHsTariff(null);
    setIsDirty(false);
    //reset tarif error display until next submit
    if (!countryHasValidation) {
      searchForHSTariff();
    } else {
      validateStopwords().then(json => {
        const success = get(json, 'success', false);
        const valid = get(json, 'all_valid', false);
        if (!success) {
          return;
        }
        setStopWordErrors(!valid);

        if (valid) {
          searchForHSTariff();
        } else {
          ReactGA.event({
            category: "das_completed_form_manual_stopword_invalid",
            action: "das_completed_form_manual_stopword_invalid",
            label: `Manual stopword invalid`,
          });
        }
      });
    }
  }

  const searchForHSTariff = () => {
    //get current value of description field
    const description = get(control._formValues, `items.${index}.description`, '');
    fetch(`${process.env.REACT_APP_PROXY_BASE_URL}/api/tariff/classify`, {
      "method": "POST",
      "headers": {
        "Content-Type": "application/json; charset=utf-8"
      },
      "body": JSON.stringify({
        "inputs": [{
          "name": description,
          "configuration": {
            "shipToCountries": currentCountry,
          }
        }
        ]
      })
    })
      .then((res) => res.json())
      .then(json => {
        const success = get(json, 'success', false);
        if (success) {
          setHsTariff(get(json, 'classifications[0]', null));
          trigger(`items.${index}.description`);
          // setIsDirty(true);
        }
      })
      .catch(err => {
        console.error.bind(console);
        ReactGA.event({
          category: "das_completed_form_manual_tariff_search_api_error",
          action: "das_completed_form_manual_tariff_search_api_error",
          label: `Manual tariff search api error ${JSON.stringify(err)}`,
        });
      });
  };

  const validateStopwords = () => {
    const description = get(control._formValues, `items.${index}.description`, '');
    return fetch(`${process.env.REACT_APP_PROXY_BASE_URL}/api/international-validation/validate-stop-word`, {
      "method": "POST",
      "headers": {
        "Content-Type": "application/json; charset=utf-8"
      },
      "body": JSON.stringify({
        "destination_country_code": currentCountry,
        "descriptions": [
          description
        ]
      })
    })
      .then((res) => res.json())
      .catch(err => {
        console.error.bind(console);
        ReactGA.event({
          category: "das_completed_form_manual_stopword_api_error",
          action: "das_completed_form_manual_stopword_api_error",
          label: `Manual stopword api error ${JSON.stringify(err)}`,
        });
      });
  }

  const validateManualTariffCode = () => {
    setIsDirty(false);
    setManualEntryModeError(false);
    const tarifCode = get(control._formValues, `items.${index}.manualTarifCode`, '').replaceAll('.', '');
    if (isEmpty(tarifCode)) {
      setValue(`items.${index}.manualTarifCode`, tarifCode, {shouldTouch: true, shouldValidate: true})
      return;
    }
    fetch(`${process.env.REACT_APP_PROXY_BASE_URL}/api/tariff/validate`, {
      "method": "POST",
      "headers": {
        "Content-Type": "application/json; charset=utf-8"
      },
      "body": JSON.stringify({
        "inputs": [
          {
            "configuration": {
              "shipToCountries": currentCountry,
              "hsCodeProvided": tarifCode
            }
          }
        ]
      })
    })
      .then((res) => res.json())
      .then(json => {
        if (!json) {
          console.log("No response from tariff validate api");
          return;
        }
        const result = get(json, 'classifications[0].hsCodeProvidedValidationResult', "");
        const hsCode = get(json, 'classifications[0].hsCode.code', null);
        setManualEntryModeError(result !== "VALID");
        if (result === "VALID") {
          setValue(`items.${index}.tarifCode`, hsCode, {shouldValidate: true});
          clearErrors(`items.${index}.tarifCode`);
          setHsTariff(get(json, 'classifications[0]', null));
        } else {
          ReactGA.event({
            category: "das_completed_form_manual_tariff_invalid",
            action: "das_completed_form_manual_tariff_invalid",
            label: `Manual tariff invalid`,
          });
        }
      })
      .catch(err => {
        console.error.bind(console);
        ReactGA.event({
          category: "das_completed_form_manual_tariff_validation_api_error",
          action: "das_completed_form_manual_tariff_validation_api_error",
          label: `Manual tariff api error ${JSON.stringify(err)}`,
        });
      });
  }

  const tarifCodeError = get(errors, `tarifCode`, false);
  console.log('NewItemForm render', {errors, tarifCodeError});

  let tarrifCardClass = "tariff-card";
  if (isSubmitted && isDirty && tarifCodeError) {
    tarrifCardClass += " error";
  }
  if (selectedTarifCode === get(hsTariff, 'hsCode.code', '')){
    tarrifCardClass += " valid";
  }

  return (
    <div className="new-item-form" ref={itemRef}>
      <div className="field">

        {multiple && <div className="deleteButtonContainer">
          <DeleteButton onClick={remove} size="small" variant="text" color="primary" endIcon={<CloseIcon/>}>
            Delete
          </DeleteButton>
        </div>}

        <div>
          <div className="descHeading">
            Enter item description to find the tariff code
          </div>
          <div className="descSubHeading">
            Be detailed and specific e.g. men’s leather shoes.
          </div>
          <Controller
            name={`items.${index}.description`}
            control={control}
            rules={{
              validate: (value) => {
                if (!hsTariff && isEmpty(value)) {
                  return "Please enter an item description and search for a tariff code."
                }
                if (specialCharRegex.test(value)) {
                  return specialCharErrorMsg;
                }

                if (!manualEntryMode && isSubmitted && !hsTariff && isEmpty(selectedTarifCode)) {
                  return "Please search for a tariff code.";
                }
                return true;
              }
            }}
            render={({field, fieldState: {error}, formState}) => {
              console.log('description field',formState.dirtyFields, formState.touchedFields);
              const isTouched = get(formState.touchedFields, `items[${index}].description`, false);
              return <TextField
                {...field}
                value={!!hsTariff ? "" : field.value}
                onChange={(e) => {
                  field.onChange(e);
                  setValue(`items.${index}.description`, e.target.value.trimStart());
                  setValue(`items.${index}.tarifCode`, '', {shouldValidate: true});
                  setHsTariff(null);
                }}
                shrink={false}
                label={null}
                // required={true}
                color='secondary'
                margin='none'
                variant='outlined'
                fullWidth
                inputProps={{maxLength: 35}}
                type="text"
                error={isTouched && !!error}
                helperText={isTouched && get(error, 'message')}
                disabled={manualEntryMode || (!!hsTariff && isEmpty(selectedTarifCode))}
                placeholder="Describe your item"
              />
            }}
          />
        </div>

        <Button
          className="btnSearchTarif"
          disabled={manualEntryMode || (!!hsTariff && isEmpty(selectedTarifCode))}
          endIcon={<SearchIcon color={(!!hsTariff && isEmpty(selectedTarifCode)) ? "rgba(0, 0, 0, 0.26)" : "white"}/>}
          fullWidth
          onClick={validateAndSearchTariff}
          size={'large'}
          variant={'contained'}
          color="secondary">
          Search for tariff code
        </Button>

        {stopWordErrors && <div className="stopwords-errors">
          <div className="icon-container">
            <span className="icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M12 4C7.589 4 4 7.589 4 12C4 16.411 7.589 20 12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4ZM12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22ZM12 14.7998C11.558 14.7998 11.2 14.4418 11.2 13.9998V6.99983C11.2 6.55883 11.558 6.19983 12 6.19983C12.441 6.19983 12.799 6.55883 12.799 6.99983L12.8 13.9998C12.8 14.4418 12.442 14.7998 12 14.7998ZM12 18C12.552 18 13 17.552 13 17C13 16.448 12.552 16 12 16C11.448 16 11 16.448 11 17C11 17.552 11.448 18 12 18Z"
                      fill="#C7352E"/>
              </svg>
            </span>
          </div>

          <div>
            <div className="message">
              Please provide a detailed and specific description of the goods being sent. Avoid product names, use plain
              English, and be specific about materials.
            </div>

            <div className="subHeading">
              For example:
            </div>

            <ul className="examples">
              <li>“Men’s leather shoes” instead of “shoes”</li>
              <li>“Women’s cotton t-shirt” instead of “clothes”</li>
              <li>“Oil painting on canvas” instead of “artwork”</li>
            </ul>
          </div>
        </div>}

        {!manualEntryMode && !stopWordErrors && hsTariff && <div className={tarrifCardClass}>
          <div className="item-label">Item description:</div>
          <div className="item-value mb-16">{get(control._formValues, `items.${index}.description`, '')}</div>

          <div className="item-label">HS tariff code:</div>
          <div className="item-value">{get(hsTariff, 'customsDescription', '')}</div>
          <div className="item-code">{get(hsTariff, 'hsCode.code', '')}</div>

          {selectedTarifCode === get(hsTariff, 'hsCode.code', '') && <span className="greenTick"><GreenTick/></span>}

          {isEmpty(selectedTarifCode) && <>
            <div className="btnUseThisTariffCode">
              <Button
                fullWidth
                onClick={() => {
                  const hsTariffCode = get(hsTariff, 'hsCode.code', '');
                  setValue(`items.${index}.tarifCode`, hsTariffCode, {shouldValidate: true});
                }}
                size={'large'} variant={'contained'}
                color="secondary">
                Use these details
              </Button>
            </div>

            <div className="btnSearchAgainTarif">
              <Button
                fullWidth
                onClick={() => {
                  setValue(`items.${index}.description`, '');
                  setValue(`items.${index}.tarifCode`, '');
                  setHsTariff(null);
                  setManualEntryModeError(false)
                }}
                size={'large'} variant={'outlined'}
                color="primary">
                Search again
              </Button>
            </div>
            <div className="manualEntryLink">
              <a
                onClick={() => {
                  clearErrors(`items.${index}.tarifCode`);
                  setManualEntryMode(true);
                  setValue(`items.${index}.manualTarifCode`, "");
                  setHsTariff(null);
                }}
                color="linkBlue">
                Enter tariff code manually
              </a>
            </div>
          </>
          }
        </div>}

        {manualEntryMode && !stopWordErrors && <div className="tariff-card">
          <span className="greenTick"><GreenTick/></span>
          <div className="item-label">Item description:</div>
          <div className="item-value">{get(control._formValues, `items.${index}.description`, '')}</div>
        </div>}

        {manualEntryMode && <Controller
          name={`items.${index}.manualTarifCode`}
          control={control}
          rules={{
            required: "Please enter and validate your HS tariff code.",
          }}
          render={({field, fieldState: {error},}) => {
            // const isTouched = get(formState.touchedFields, `items[${index}].manualTarifCode`, false);
            const usOrIreland = (currentCountry === 'IE' || currentCountry === 'US');
            const helperText = usOrIreland ? "A 10-digit code is required for the country you are sending to.":"";
            const hasError = !!tarifCodeError || !!error;
            const currentErrorMSg = !!tarifCodeError ? "Please enter and validate your HS tariff code." :
              !!error ? get(error, 'message', null) : "";
            const currentHelperTxt = hasError ?  currentErrorMSg : helperText;
            console.log('manualTarifCode field render', {error, tarifCodeError});

              return (
                <div className="hsTariffManualField">
                  <TextField
                    {...field}
                    value={field.value}
                    onChange={(e) => {
                      field.onChange(e);
                      setValue(`items.${index}.manualTarifCode`, e.target.value.trimStart());
                    }}
                    error={hasError}
                    placeholder="HS tariff code"
                    helperText={currentHelperTxt}
                    shrink={false}
                    label={null}
                    color='secondary'
                    margin='none'
                    variant='outlined'
                    inputProps={{maxLength: 18}}
                    fullWidth
                    type="text"
                  />
                </div>
              )
          }}
        />}
        <Controller
          name={`items.${index}.tarifCode`}
          control={control}
          rules={{
            required: "Please select an option."
          }}
          render={({field, fieldState: {error},}) => {
            console.log('TarifCode hidden field render', {
              manualEntryMode,
              isDirty,
              hsTariff,
              selectedTarifCode,
              error});
            if (!manualEntryMode && isDirty && hsTariff && isEmpty(selectedTarifCode) && error) {
              return <FormHelperText error={true}>
                {error.message}
              </FormHelperText>;
            }
            return null;
          }}
        />
        {manualEntryMode && <>
          <div className="btnValidateManualTarif">
            <Button
              // disabled={!!hsTariff && isEmpty(selectedTarifCode)}
              endIcon={<SearchIcon color="white" />}
              fullWidth
              onClick={validateManualTariffCode}
              size={'large'}
              variant={'contained'}
              color="secondary">
              Validate code
            </Button>
          </div>
          {!manualEntryError && hsTariff && selectedTarifCode === get(hsTariff, 'hsCode.code', '')
            && <div className="manualTarifValidationResult">
              <div className={tarrifCardClass}>
                <span className="greenTick"><GreenTick/></span>
                <div className="item-label">HS tariff code:</div>
                <div className="item-value">{get(control._formValues, `items.${index}.tarifCode`, '')}</div>
              </div>
            </div>}
          {manualEntryError && <div className="stopwords-errors">
            <div className="icon-container">
            <span className="icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M12 4C7.589 4 4 7.589 4 12C4 16.411 7.589 20 12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4ZM12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22ZM12 14.7998C11.558 14.7998 11.2 14.4418 11.2 13.9998V6.99983C11.2 6.55883 11.558 6.19983 12 6.19983C12.441 6.19983 12.799 6.55883 12.799 6.99983L12.8 13.9998C12.8 14.4418 12.442 14.7998 12 14.7998ZM12 18C12.552 18 13 17.552 13 17C13 16.448 12.552 16 12 16C11.448 16 11 16.448 11 17C11 17.552 11.448 18 12 18Z"
                      fill="#C7352E"/>
              </svg>
            </span>
            </div>
            <div>
              <div className="message">
                The HS tariff code you have entered is not valid. Please try again.
              </div>
            </div>
          </div>}
          <div className="backToSearchLink">
            <a
              onClick={() => {
                setHsTariff(null);
                setManualEntryMode(false);
                setManualEntryModeError(false);
                clearErrors(`items.${index}.manualTarifCode`);
              }}
              color="linkBlue">
              Back to search
            </a>
          </div>
        </>}

      </div>

      <div className="field">
        <div className="subHead">
          Country of origin {!countryOriginRequired && "(optional)"}
        </div>

        <Controller
          name={`items.${index}.countryOrigin`}
          control={control}
          rules={{
            required: countryOriginRequired && "Please provide this item's country of origin.",
          }}
          render={({field, fieldState: {error}}) => {
            return (
              <CountrySelect
                {...field}
                error={!!error}
                helperText={get(error, 'message')}
                shrink={false}
                clicked={true}
                label={null}
              />
            )
          }}
        />
      </div>

      <div className="field">
        <div className="subHead">
          Quantity
        </div>
        <Controller
          name={`items.${index}.quantity`}
          control={control}
          rules={{
            required: "Please provide a quantity for this item.",
            validate: (value) => {
              // if (isEmpty(value)) return true;
              return (
                (value && value > 0 && value <= 999999999999999) || "Please provide a quantity for this item."
              );
            },
            pattern: /^[1-9]\d*$/
          }}
          render={({field, fieldState: {error}}) => (
            <TextField
              {...field}
              onChange={(e) => {
                field.onChange(e);
                setValue(`items.${index}.quantity`, e.target.value.trimStart());
              }}
              error={!!error}
              helperText={get(error, 'message')}
              shrink={false}
              label={null}
              // required={true}
              color='secondary'
              margin='none'
              variant='outlined'
              fullWidth
              type="text"
              inputProps={{
                step: 1,
                min: 1.,
                max: 999999999999999.,
                maxLength: 15,
                onKeyDown: numericKeyPressOnly(15, 0),
                autocomplete: 'do-not-ever-autocomplete-quantity'
              }}
            />
          )}
        />

      </div>

      <div className="field">
        <div className="subHead">
          Weight in kg
        </div>
        <Controller
          name={`items.${index}.weight`}
          control={control}
          rules={{
            required: "Please provide this item's weight.",
            validate: (value) => {
              // if (isEmpty(value)) return true;
              return (
                (value && value >= 0.001 && value <= 999999.999) || "Please provide this item's weight."
              )
            },
            pattern: /^\d{0,6}(\.\d{0,3})?$/
          }}
          render={({field, fieldState: {error}}) => (
            <TextField
              onChange={(e) => {
                field.onChange(e);
                setValue(`items.${index}.weight`, e.target.value.trimStart());
              }}
              {...field}
              error={!!error}
              helperText={get(error, 'message')}
              shrink={false}
              label={null}
              // required={true}
              color='secondary'
              margin='none'
              variant='outlined'
              fullWidth
              name='weight'
              type="text"
              inputProps={{
                step: 1,
                min: 0.001,
                max: 999999.000,
                maxLength: 10,
                onKeyDown: numericKeyPressOnly(6, 3),
                autocomplete: 'do-not-ever-autocomplete-weight'
              }}
            />
          )}
        />
      </div>

      <div className="field">
        <div className="subHead">
          Value in NZD
        </div>
        <Controller
          name={`items.${index}.value`}
          control={control}
          rules={{
            // required: "Please provide this item's value.",
            validate: (value) => {
              // if (isEmpty(value)) return true;
              return (
                (value && value >= .01 && value <= 999999.99) || "Please provide this item's value."
              );
            },
            pattern: /^\d{0,6}(\.\d{0,2})?$/
          }}
          render={({field, fieldState: {error}}) => (
            <TextField
              {...field}
              onChange={(e) => {
                field.onChange(e);
                setValue(`items.${index}.value`, e.target.value.trimStart());
              }}
              error={!!error}
              helperText={get(error, 'message')}
              shrink={false}
              label={null}
              // required={true}
              color='secondary'
              margin='none'
              variant='outlined'
              fullWidth
              name='value'
              type="text"
              inputProps={{
                step: 1,
                min: .01,
                maxLength: 9,
                onKeyDown: numericKeyPressOnly(6, 2),
                autocomplete: 'do-not-ever-autocomplete-value'
              }}
            />
          )}
        />
      </div>
    </div>
  );
}

export default NewItemForm;